import type { Distance, Pixel } from "@pdfking/math"
import type { PdfEngineOptions } from "../types/engine/PdfEngineOptions"
import { RecordMap } from "@pdfking/tfunc"

export const ConvertPixels = <T extends Record<string, Pixel>>(
  options: PdfEngineOptions,
  rect: T
): { [K in keyof T]: Distance } =>
  RecordMap(v => ((v as number) / options.unit_to_px) as Distance, rect)
